import { AppState } from '@/app/data';

export default {
    namespaced: true,

    state: {
        currentStatus: AppState.READYTOSTART
    },

    getters: {
        currentStatus: ( state ) =>
        {
            return state.currentStatus;
        }
    },

    mutations: {
        changeStatus: ( state, newStatus ) =>
        {
            state.currentStatus = newStatus;
        }
    },

    actions: {
        changeStatus: ( context, newStatus ) =>
        {
            context.commit( 'changeStatus', newStatus );
        }
    }
};
